import { DateTime } from "luxon";

/**
 * Converts date parts (in Newfoundland time) to a UTC JavaScript Date object
 */
export const getUTCDateFromParts = ({ year, month, day }) => {
  const dt = DateTime.fromObject(
    { year, month, day },
    { zone: "America/St_Johns" }
  );
  return dt.toUTC().toJSDate(); // JS Date object in UTC
};
